import { createAction, props } from '@ngrx/store';
import { types } from './types';

export const setLoginSelectedLanguage = createAction(
    types.SET_LOGIN_SELECTED_LANGUAGE,
    props<{ loginSelectedLanguage: string }>()
);
